import { Icon } from '@design-system/index'
import * as React from 'react'
import { useEffect } from 'react'

import _Button from '@/component/atoms/Button/_Button/_Button'
import { academyController } from '@/controller/academy.controller'
import modalService from '@/service/modal.service'

import S from './FirstLoginWelcomeModal.style'

const FirstLoginWelcomeModal = () => {
  useEffect(() => {
    void academyController.initializeAcademy()
  }, [])

  return (
    <S.Wrap>
      <Icon name="check_circle" size={36} color="var(--Colors-Teal-500)" />
      <div className="title">사이언스플랫에 오신 것을 환영합니다!</div>
      <div className="body">
        <p>사이언스플랫은 매쓰플랫에 등록되어 있는 학생과 선생님을 공유해요.</p>
        <p>과학수업에도 쉽고 간편하게 사이언스플랫을 활용해보세요!</p>
      </div>
      {/* <_Button size="m" theme="primary" minWidth={120} onClick={() => modalService.closeModal()}>
        확인
      </_Button> */}
    </S.Wrap>
  )
}

export default FirstLoginWelcomeModal
